import { createSelector } from 'reselect';
const testDetails = state =>  state.singleTestInfo && state.singleTestInfo.response;
// console.log(testDetails, 'testdetails from selector');


export const testDetailsSelector = createSelector(
 testDetails, 
  details => {
    const {
        time_remaining_to_start,
        time_remaining_to_end,
        can_user_attempt,
        mock_test_details = {},
        user_test_status,
        mock_test_subjects,
        completed
        
    } = details || {};
    
    const {
        id,
        mock_series_code,
        title,
        mock_test_code,
        image_url,
        duration,
        no_of_questions,       
        schedule,
        start_date_time,
        end_date_time,
        is_free,
        description,
        video_url
        
    } = mock_test_details;

    return {
        time_remaining_to_start,
        time_remaining_to_end,
        can_user_attempt,
        id,
        mock_series_code,
        title,
        mock_test_code,
        image_url,
        duration,
        no_of_questions,       
        schedule,
        start_date_time,
        end_date_time,
        is_free,
        mock_test_subjects,
        user_test_status,
        completed,
        description,
        video_url
    }
  }
);
